import {fetch} from "../utils/fetch";
import { casaApiUrl } from 'configs/casa-api'
import moment from 'moment-timezone'
import queryString from 'query-string'

function getCustomerInterests (filter) {
  let {startDate, endDate, storeNames} = filter.toJSON()
  let startDateParam = moment(startDate).format('YYYY-MMM-DD')
  let endDateParam = moment(endDate).format('YYYY-MMM-DD')
  let query = queryString.stringify({
    startDate: startDateParam,
    endDate: endDateParam,
    stores: storeNames
  }, {arrayFormat: 'bracket'})
  return fetch(`${casaApiUrl}/users/customer-interests/filter?${query}`, {
    credentials: 'include',
    method: 'GET'
  }).then(res => res.json())
}

export default {
  getCustomerInterests
}



// WEBPACK FOOTER //
// ./src/services/customer-interests-service.js